import { render, staticRenderFns } from "./ModuleKnowlegeAtlas.vue?vue&type=template&id=397e95a3&scoped=true"
import script from "./ModuleKnowlegeAtlas.vue?vue&type=script&lang=js"
export * from "./ModuleKnowlegeAtlas.vue?vue&type=script&lang=js"
import style0 from "./ModuleKnowlegeAtlas.vue?vue&type=style&index=0&id=397e95a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397e95a3",
  null
  
)

export default component.exports